exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerText {\r\n    padding: 10px;\r\n}\r\n.disclaimer {\r\n    margin: 4px 4px 4px 4px;\r\n}\r\n\r\n.disclaimer-title {\r\n    font-size: 14px;\r\n    color: gray;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.dx-accordion-item-opened {\r\n    background-color: #F4F6FB;\r\n}\r\n\r\n.disclaimer-text {\r\n    font-size: 12px;\r\n    color: #7c8193;\r\n}\r\n\r\n.disclaimer-text-part2 {\r\n    font-size: 18px;\r\n    color: #7c8193;\r\n}\r\n\r\n\r\n.dx-state-focused.dx-accordion-item {\r\n    border-color:lightgray;\r\n    border-radius: 4px;\r\n}\r\n\r\n.dx-accordion-item-opened > .dx-accordion-item-title:before {\r\n    content: unset;\r\n}\r\n\r\n#page-container {\r\n    position: relative;\r\n    min-height: 100vh;\r\n}\r\n\r\n/* Footer height */\r\n/*#content-wrap {\r\n    padding-bottom: 33rem;\r\n}*/\r\n\r\n/*#footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 100%;\r\n}*/\r\n\r\n/*.footer-footer {\r\n    background-color: black;\r\n    color: dimgray;\r\n    font-size: 12px;    \r\n}*/", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./App/containers/layout/layout.css
// module id = 846
// module chunks = 0